export type DeploymentEnvironment = 'development' | 'production' | 'stage' | 'test';

export function resolveDeploymentEnvironment(
  configured = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT,
  nodeEnvironment = process.env.NODE_ENV,
): DeploymentEnvironment {
  const value = configured?.trim().toLowerCase();
  if (value === 'development' || value === 'production' || value === 'stage' || value === 'test') {
    return value;
  }
  if (value) return 'test';
  if (nodeEnvironment === 'production') return 'production';
  if (nodeEnvironment === 'test') return 'test';
  return 'development';
}

export const deploymentEnvironment = resolveDeploymentEnvironment();
export const isStageDeployment = deploymentEnvironment === 'stage';
export const isIndexableDeployment = deploymentEnvironment === 'production';